import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class LoadingService {
//   public modal$: Observable<any>;
//   private modalNameSubject: Subject<any>;

  public loading$: Observable<any>;
  public loadingSubject: Subject<any>;
  public isCurrentlyLoading: Boolean = false;

  constructor() {
    this.loadingSubject = new Subject<any>();
    this.loading$ = this.loadingSubject.asObservable();
  }

  isLoading(status) {
    this.loadingSubject.next(status);
    this.isCurrentlyLoading = status;
  }
}